import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginFixedToolbar implements ILectioPlugin {
	public Init(): void {
		//http://ckeditor.com/addon/fixed - se kommentar felt
		CKEDITOR.plugins.add('fixedtoolbar', {
			init: editor => {
				editor.on('instanceReady', readyEvent => {
					const scrollParent = $(window);
					scrollParent.scroll(e => {
						PluginFixedToolbar.FixToolbar(readyEvent.editor);
					});
					scrollParent.resize(e => {
						PluginFixedToolbar.FixToolbar(readyEvent.editor);
					});
					//da toolbar kun scroller med når editoren har focus håndterer vi også følgende events
					readyEvent.editor.on('focus', ei => PluginFixedToolbar.FixToolbar(readyEvent.editor));
					readyEvent.editor.on('blur', ei => PluginFixedToolbar.FixToolbar(readyEvent.editor));
				});
			}
		});
	}

	private static FixToolbar(e: CKEDITOR.editor): void {
		const editor = e.container.$;
		const content = editor.getElementsByClassName('cke_contents').item(0) as HTMLElement;
		const toolbarObj = LCDocumentEditorUtils.GetToolbarObject(e);
		const toolbar = toolbarObj[0];

		const scrollvalue = $(window).scrollTop()!;

		const $content = $(content);

		toolbar.style.width = $content.width()! + "px";
		toolbar.style.top = "0px";
		toolbar.style.left = "0px";
		toolbar.style.right = "0px";
		//toolbar.style.margin = "0 auto";
		toolbar.style.boxSizing = "border-box";

		const $editor = $(editor);
		const editorOffset = $editor.offset()!;
		const editorOuterHeight = $editor.outerHeight()!;
		const toolbarOuterHeight = $(toolbar).outerHeight()!;

		if ($(editor).hasClass('cke_focus')
			&& editorOffset.top <= scrollvalue
			&& (editorOffset.top + editorOuterHeight) > (scrollvalue + toolbarOuterHeight + 50)) {
			toolbar.style.position = "fixed";
			toolbar.style.left = $content.position().left + "px";
			content.style.marginTop = toolbarOuterHeight + "px";
		} else {
			toolbar.style.position = "relative";
			content.style.marginTop = "0px";
		}
	}
}
